import React, { Component } from "react";
import { Container, Card } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import ViewExams from "./ViewExams";
import ExamTypes from "./ExamTypes";
import CreateExam from "./CreateExam";
import ExamTypeConfig from "./ExamTypeConfig";
import ExamSubjectsConfig from "./SubjectWiseConfig";
import MarksEntry from "./MarksEntry";
import ExamInternals from "./ExamInternals";
import PrintReport from "./PrintReport";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import CreateClassSubjects from "./CreateClassSubjects";

/* ---------- LOADER ---------- */
const Loader = () => (
  <div style={{ textAlign: "center", padding: 60 }}>
    <div className="spinner-border text-primary" />
    <p style={{ marginTop: 10 }}>Loading...</p>
  </div>
);

/* ---------- TABS ---------- */
const BASE_PATH = "/Offline_Examiantions";

const TAB_CONFIG = [
  { key: "EXAM TYPE", slug: "exam-type", label: "Exam Type", icon: "fas fa-clipboard-list", component: ExamTypes },
  { key: "CREATE CLASS SUBJECTS", slug: "create-class-subjects", label: "Create Class Subjects", icon: "fas fa-tools", component: CreateClassSubjects },
  { key: "CREATE EXAM", slug: "create-exam", label: "Create Exam", icon: "fas fa-pencil-alt", component: CreateExam },
  { key: "EXAM TYPE CONFIG", slug: "type-config", label: "Type Config", icon: "fas fa-cog", component: ExamTypeConfig },
  { key: "EXAM SUBJECTS CONFIG", slug: "exam-subjects-config", label: "Exam Subjects Config", icon: "fas fa-chart-bar", component: ExamSubjectsConfig },
  // { key: "EXAM INTERNALS", label: "Marks Config", icon: "fas fa-book-open", component: ExamInternals },
  { key: "MARKS ENTRY", slug: "marks-entry", label: "Marks Entry", icon: "fas fa-file-alt", component: MarksEntry },
  { key: "PRINT REPORT", slug: "print-report", label: "Print Report", icon: "fas fa-print", component: PrintReport },
];

/* ---------- STYLES ---------- */
const styles = {
  page: {
    background: "linear-gradient(135deg, #f0f4ff, #faf5ff)",
    minHeight: "100vh",
    padding: 20,
  },
  headerCard: {
    borderRadius: 16,
    border: "none",
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
    marginBottom: 20,
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    marginBottom: 10,
  },
};

/* ---------- MAIN CLASS ---------- */
class OfflineHomeExaminations extends Component {
  componentDidMount() {
    // Normalize bare base URL to the default tab's sub-URL
    if (!this.props.match?.params?.tab) {
      this.props.history.replace(`${BASE_PATH}/${TAB_CONFIG[0].slug}`);
    }
  }

  getActiveTab = () => {
    const slug = this.props.match?.params?.tab;
    const cfg = TAB_CONFIG.find((t) => t.slug === slug);
    return cfg ? cfg.key : TAB_CONFIG[0].key;
  };

  changeTab = (tab) => {
    toast.dismiss();
    const cfg = TAB_CONFIG.find((t) => t.key === tab) || TAB_CONFIG[0];
    this.props.history.push(`${BASE_PATH}/${cfg.slug}`);
  };

  /* ---------- TABS (expense-style strip) ---------- */
  renderTabs = () => {
    const activeTab = this.getActiveTab();
    const activeConfig = TAB_CONFIG.find((t) => t.key === activeTab) || TAB_CONFIG[0];
    const ComponentToRender = activeConfig.component;

    return (
      <>
        {/* Tab strip */}
        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 12px 0", borderRadius: "12px 12px 0 0" }}>
          <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8, flexWrap: "wrap" }}>
            {TAB_CONFIG.map((tab) => {
              const active = activeTab === tab.key;
              return (
                <li className="nav-item" key={tab.key}>
                  <a
                    href="#"
                    className={`nav-link ${active ? "active" : ""}`}
                    onClick={(e) => { e.preventDefault(); this.changeTab(tab.key); }}
                    style={{
                      cursor: "pointer",
                      fontWeight: 700,
                      fontSize: 14,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "12px 20px",
                      color: active ? "#6366f1" : "#4b5563",
                      background: active ? "#fff" : "transparent",
                      borderColor: active ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                      borderWidth: "1.5px",
                      borderBottomWidth: active ? "2px" : "1.5px",
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.15s ease",
                      marginBottom: "-1.5px",
                    }}
                  >
                    <i className={tab.icon} /> {tab.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Active tab content */}
        <div style={{ padding: "20px 0" }}>
          <ComponentToRender
            getClasses={this.props.getExamClassesQuery?.getExamClasses}
            getYears={this.props.getAcademicYearsQuery?.getAcademicYears}
            getExamBoards={this.props.getExamBoardsQuery?.getExamBoards}
            getExamPhase={this.props.getExamPhasesQuery?.getExamPhases}
            getBranchesQuery={this.props.getBranchesQuery?.getBranches}
            getStreams={this.props.getStreamsQuery?.getStreams}
          />
        </div>
      </>
    );
  };

  render() {
    const {
      getExamClassesQuery,
      getAcademicYearsQuery,
      getExamPhasesQuery,
      getExamBoardsQuery,
    } = this.props;

    if (
      getExamClassesQuery?.loading ||
      getAcademicYearsQuery?.loading ||
      getExamPhasesQuery?.loading ||
      getExamBoardsQuery?.loading
    ) {
      return <Loader />;
    }

    return (
      <div style={styles.page}>
        <Container fluid>
          <Card style={styles.headerCard}>
            <Card.Body>
              {this.renderTabs()}
            </Card.Body>
          </Card>
        </Container>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    );
  }
}

/* ---------- GRAPHQL ---------- */
const GET_ACADEMIC_YEARS = gql`
  query getAcademicYears($id: Int) {
    getAcademicYears(id: $id) {
      id
      academic_year
    }
  }
`;

const GET_EXAM_CLASSES = gql`
  query getExamClasses($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_EXAM_BOARDS = gql`
  query getExamBoards($id: Int) {
    getExamBoards(id: $id) {
      board_id
      exam_board_name
    }
  }
`;

const GET_EXAM_PHASES = gql`
  query getExamPhases($institute_id: Int!) {
    getExamPhases(institute_id: $institute_id) {
      id
      exam_phase
      exam_standard_id
      exam_standard_name
      academic_year_id
      academic_year
    }
  }
`;

const GET_STREAMS = gql`
  query {
    getStreams {
      id
      stream
      classes
    }
  }
`;

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

export default withRouter(
  compose(

    graphql(GET_EXAM_CLASSES, {
      options: (props) => ({
        variables: {
          id: 1
        },
      }),
      name: "getExamClassesQuery",
    }),


    graphql(GET_EXAM_PHASES, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getExamPhasesQuery",
    }),

    graphql(GET_EXAM_BOARDS, {
      options: (props) => ({
        variables: {
          id: 1
        },
      }),
      name: "getExamBoardsQuery",
    }),


    graphql(GET_ACADEMIC_YEARS, {
      options: (props) => ({
        variables: {
          id: 1
        },
      }),
      name: "getAcademicYearsQuery",
    }),

    graphql(GET_BRANCHES, {
      name: "getBranchesQuery",
      options: () => ({
        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
      }),
    }),

    graphql(GET_STREAMS, {
      name: "getStreamsQuery",
    }),

  )(OfflineHomeExaminations)
);
